<div class="import-container glass-effect">
  <div class="header">
    <div class="title-section">
      <mat-icon class="header-icon">upload_file</mat-icon>
      <h2>Import Medications</h2>
    </div>
    <button mat-icon-button (click)="close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="instruction-card">
      <p>Upload a CSV file to bulk Add, Edit, or Delete medications. Ensure your file follows the required format.</p>
      <button mat-stroked-button color="primary" (click)="downloadTemplate()">
        <mat-icon>download</mat-icon>
        Download Template
      </button>
    </div>

    <div class="action-selection">
      <label>Choose Action:</label>
      <mat-radio-group [(ngModel)]="action" [disabled]="isImporting">
        <mat-radio-button value="add">Add New</mat-radio-button>
        <mat-radio-button value="edit">Edit Existing</mat-radio-button>
        <mat-radio-button value="delete">Delete</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="upload-section" [class.active]="selectedFile" (click)="fileInput.click()">
      <input #fileInput type="file" (change)="onFileSelected($event)" accept=".csv" hidden>
      
      <div class="upload-placeholder" *ngIf="!selectedFile">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p>Click to select or drag and drop CSV file</p>
      </div>

      <div class="selected-file" *ngIf="selectedFile">
        <mat-icon class="file-icon">description</mat-icon>
        <div class="file-info">
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">{{ (selectedFile.size / 1024).toFixed(2) }} KB</span>
        </div>
        <button mat-icon-button (click)="$event.stopPropagation(); selectedFile = null" [disabled]="isImporting">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <div class="import-progress" *ngIf="isImporting">
      <p>Processing medications... {{ progress }}%</p>
      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
    </div>

    <div class="results-section" *ngIf="!isImporting && (importResults.success.length > 0 || importResults.failure.length > 0)">
      <div class="result-summary">
        <div class="stat success">
          <span class="count">{{ importResults.success.length }}</span>
          <span class="label">Successful</span>
        </div>
        <div class="stat failure">
          <span class="count">{{ importResults.failure.length }}</span>
          <span class="label">Failed</span>
        </div>
      </div>

      <div class="failure-actions" *ngIf="importResults.failure.length > 0">
        <p>Some rows could not be processed. Download the failure report to see details.</p>
        <button mat-flat-button color="warn" (click)="downloadFailedRows()">
          <mat-icon>download</mat-icon>
          Download Failed Rows
        </button>
      </div>
    </div>
  </div>

  <div class="actions">
    <button mat-button (click)="close()" [disabled]="isImporting">Cancel</button>
    <button mat-flat-button color="primary" 
            [disabled]="!selectedFile || isImporting" 
            (click)="startImport()">
      <mat-icon>play_arrow</mat-icon>
      Start Import
    </button>
  </div>
</div>
